import getTaskType from '../../utils/getTaskType';
import { getTimeZoneOffset, formatDate, getTimeFromDateString, getDateFromDateString } from '../../utils/utils';

class TaskRegular {
  constructor(task = {}) {
    this.id = task.id || '';
    this.extId = task.extId || '';

    this.globalTaskId = task.globalTaskId || null;

    this.type = task.type || getTaskType(false, true, false);

    this.title = task.title || '';
    this.subtitle = task.subtitle || '';
    this.description = task.description || '';
    this.note = task.note || '';

    this.startDate = task.startDate || formatDate();
    this.endDate = task.endDate || formatDate();

    // technical value for filter/sort
    this.date = this.endDate;

    this.timeZone = task.timeZone === 0 ? task.timeZone : task.timeZone || getTimeZoneOffset();
    this.time = task.time || '';
    this.timeNeed = Number(task.timeNeed) || 0;
    this.frequency = task.frequency || '';
    this.intervalName = task.intervalName || '';
    this.intervalValue = task.intervalValue || 0;

    this.importance = task.importance || false;
    this.done = task.done || false;

    this.delayedTaskId = task.delayedTaskId || null;

    this.labels = task.labels || [];

    // tasks structure
    this.taskGlobal = task.taskGlobal || null;
    this.tasksSingle = task.tasksSingle || [];
  }

  getCreateTaskRegularDto({ isTasksSingleTitlesUpdated = false } = {}) {
    const serverModel = {
      globalTaskId: null,
      title: null,
      subTitle: null,
      description: null,
      note: null,
      timeNeed: null,
      isImportant: null,
      isDone: null,
      frequency: null,
      intervalName: null,
      intervalValue: null,
      time: null,
      startDate: null,
      endDate: null,
      timeZone: null,

      isTasksSingleTitlesUpdated: null,
    };

    if (this.globalTaskId) serverModel.globalTaskId = this.globalTaskId;
    if (this.title) serverModel.title = this.title;
    if (this.subtitle) serverModel.subTitle = this.subtitle;
    serverModel.description = this.description;
    serverModel.note = this.note;
    if (this.startDate) serverModel.startDate = this.startDate;
    if (this.endDate) serverModel.endDate = this.endDate;
    if (this.timeZone || this.timeZone === 0) serverModel.timeZone = getTimeZoneOffset();
    if (this.time) serverModel.time = new Date(new Date().setHours(Number(this.time.split(':')[0]), Number(this.time.split(':')[1]), 0));
    serverModel.timeNeed = this.timeNeed * 60 || 0; // to minutes
    if (this.frequency) serverModel.frequency = this.frequency;
    if (this.intervalName) serverModel.intervalName = this.intervalName;
    if (this.intervalValue) serverModel.intervalValue = this.intervalValue;
    if (this.labels) serverModel.labels = this.labels;
    serverModel.isImportant = this.importance || false;
    serverModel.isDone = this.done || false;
    Object.keys(serverModel).forEach((key) => {
      if (serverModel[key] === null) {
        delete serverModel[key];
      }
    });
    if (this.delayedTaskId) serverModel.delayedTaskId = this.delayedTaskId;

    if (!this.time) serverModel.time = null;

    serverModel.isTasksSingleTitlesUpdated = isTasksSingleTitlesUpdated;

    return serverModel;
  }

  getTaskRegular(serverModel) {
    this.id = serverModel.id || '';
    this.extId = serverModel.extId || '';

    this.globalTaskId = serverModel.globalTaskId || null;

    this.type = getTaskType(false, true, false);

    this.title = serverModel.title || '';
    this.subtitle = serverModel.subTitle || '';
    this.description = serverModel.description || '';
    this.note = serverModel.note || '';

    this.startDate = serverModel.startDate ? getDateFromDateString(serverModel.startDate) : '';
    this.endDate = serverModel.endDate ? getDateFromDateString(serverModel.endDate) : '';

    // technical value for filter/sort
    this.date = this.endDate;

    this.timeZone = serverModel.timeZone === 0 ? serverModel.timeZone : serverModel.timeZone || getTimeZoneOffset();
    this.time = serverModel.time ? getTimeFromDateString(serverModel.time, this.timeZone) : '';
    this.timeNeed = Number(serverModel.timeNeed) / 60 || 0; // to hours
    this.frequency = serverModel.frequency || '';
    this.intervalName = serverModel.intervalName || '';
    this.intervalValue = serverModel.intervalValue || 0;

    this.importance = serverModel.isImportant || false;
    this.done = serverModel.isDone || false;

    this.labels = serverModel.labels || [];

    // tasks structure
    this.taskGlobal = serverModel.taskGlobal || null;
    this.tasksSingle = serverModel.tasksSingle || [];

    return this;
  }
}

export default TaskRegular;
